import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  FaStar,
  FaHeart,
  FaRegHeart,
  FaBalanceScale,
  FaAward,
  FaCreditCard,
  FaChevronLeft,
  FaChevronRight,
  FaArrowAltCircleRight,
} from "react-icons/fa";
import { LuShoppingCart } from "react-icons/lu";

import paypal from "../assets/Footer/paypal.png";
import mastercard from "../assets/Footer/mastercard.png";
import visa from "../assets/Footer/visa.png";
import amex from "../assets/Footer/amex.png";

import macbook from "../assets/pds/macbook.png";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function ProductDetail() {
  const [activeTab, setActiveTab] = useState("description");
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [fullProduct, setFullProduct] = useState([]);
  // const location = useLocation();
  // const { itemId } = location.state || {};
  // const { ID } = location.state || {};
  const { itemId, ID } = useParams();

  const cutitemId = itemId ? itemId.split(" ")[0] : "";

  const [images, setImages] = useState([]);

  // const [currentIndex, setCurrentIndex] = useState(0);
  const [quantities, setQuantities] = useState({});

  const [selectedVariant, setSelectedVariant] = useState("");

  const [wishlist, setWishlist] = useState([]);
  const [loadingWishlist, setLoadingWishlist] = useState(true);

  //import from product details
  const options = ["64GB", "128GB", "512GB"];
  // const thumbnails = [macbook, 1, 2, 3, 4];
  // const [selectedImage, setSelectedImage] = useState(thumbnails[0]);

  const thumbnailContainerRef = useRef(null);

  const scrollLeft = () => {
    if (thumbnailContainerRef.current) {
      thumbnailContainerRef.current.scrollBy({
        left: -100,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (thumbnailContainerRef.current) {
      thumbnailContainerRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  // console.log("split word itemid:",cutitemId);
  // console.log("itemID:", itemId);
  // console.log("ID:", ID);

  const customerType = localStorage.getItem("CustomerType");

  const ledname = localStorage.getItem("LedName");
  const ledcode = localStorage.getItem("Ledcode");
  const ledemail = localStorage.getItem("LedEmail");

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

  // const [mainImage, setMainImage] = useState(`${apiLocalUrl}/uploads/${ID}.jpg?v=${Date.now()}`);
  const [selectedImage, setSelectedImage] = useState(
    `${apiLocalUrl}/uploads/${ID}.jpg?v=${Date.now()}`
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
          `${apiBaseUrl}/getProductByFilter/JAPAN_ACCESORIES?filter=${encodeURIComponent(
            cutitemId
          )}`
        );
        const data = await response.json();
        setProducts(data.slice(0, 4));
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, [apiBaseUrl, cutitemId]);

  useEffect(() => {
    const fetchFullProducts = async () => {
      try {
        const response = await fetch(
          `${apiBaseUrl}/getProductByFilter/JAPAN_ACCESORIES?filter=${encodeURIComponent(
            itemId
          )}`
        );
        const data = await response.json();
        setFullProduct(data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchFullProducts();
  }, [apiBaseUrl, itemId]);

  useEffect(() => {
    fetch(
      `${apiBaseUrl}/stock/getImages/JAPAN_ACCESORIES?itemname=${encodeURIComponent(
        itemId
      )}&itemid=${encodeURIComponent(ID)}`
    )
      .then((response) => response.json())
      .then((data) => {
        const imageUrls = data.map((item) => {
          const binaryString = item.Image.data.reduce(
            (acc, byte) => acc + String.fromCharCode(byte),
            ""
          );
          const base64String = btoa(binaryString);
          return `data:image/jpeg;base64,${base64String}`;
        });
        setImages(imageUrls);
      })
      .catch((error) => console.error("Error fetching images:", error));
  }, [apiBaseUrl, ID, itemId]);

  // const handlePrevClick = () => {
  //     setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : 0));
  // };

  // const handleNextClick = () => {
  //     setCurrentIndex((prevIndex) => (prevIndex < images.length - 3 ? prevIndex + 1 : images.length - 3));
  // };

  // const handleThumbnailClick = (image) => {
  //     setMainImage(image);
  // };

  // const home = async () => {
  //   navigate("/home")
  // }

  const fullimage = (itemId, ID, customerType) => {
    navigate(`/fullimage/${itemId}/${ID}/${customerType}`);
    window.location.reload();
  };

  const items = async () => {
    navigate("/allproducts", { state: { cutitemId: cutitemId } });
  };

  // const newarrival = (id,Name) => {
  //   navigate('/fullimage', { state: { categoryId: 691, Name: 'NEW ARRIVAL', category:'HOME' } });
  // };

  const generateUniqueCode = () => {
    return (
      Date.now().toString(36) + // Timestamp in base36
      Math.random().toString(36).substring(2, 8).toUpperCase() // Random 6 chars
    );
  };

  const getNumericPrice = (product) => {
    switch (customerType) {
      case "CUSTOMER":
        return product.MOP ?? product.MRP;
      case "AGENT":
        return product.AP ?? product.MRP;
      case "DEALER":
        return product.DP ?? product.MRP;
      case "JS_EMPLOYEE":
      case "TK_EMPLOYEE":
      case "JS_MANAGER":
      case "TK_MANAGER":
        return product.MRP;
      default:
        return product.MRP;
    }
  };

  const handleAddToCart = (productId) => {
    console.log(productId);
    const product = products.find((p) => p.ID === productId);
    console.log(product);

    if (!product) {
      console.error("❌ Product not found for ID:", productId);
      toast.error("Product not found. Please refresh the page.");
      return;
    }

    addToCart(product);
  };

  // Add to Cart function

  const addToCart = async (product) => {
    const quantity = quantities[product.ID];

    if (quantity === "" || !/^\d+$/.test(quantity) || Number(quantity) <= 0) {
      toast.error("Please enter a valid quantity");
      return;
    }

    const qtyNumber = Number(quantity);
    const existingData = JSON.parse(localStorage.getItem("productData")) || [];

    // const index = existingData.findIndex((item) => item.id === product.ID);
    const index = existingData.findIndex(
      (item) =>
        item.id === product.ID && item.selectedVariant === selectedVariant
    );

    let quantityDifference = qtyNumber;
    let uniqueCode = generateUniqueCode();
    // let uniqueCode = "0";

    if (index !== -1) {
      const updatedQuantity = existingData[index].quantity + qtyNumber;
      if (updatedQuantity > product.Qty) {
        toast.error(`Total quantity exceeds stock (${product.Qty})`);
        return;
      }

      // Keep old code
      uniqueCode = existingData[index].uniqueCode;

      existingData[index].quantity = updatedQuantity;
    } else {
      if (qtyNumber > product.Qty) {
        toast.error(`Available stock is ${product.Qty}`);
        return;
      }

      existingData.push({
        itemName: product.ItemName,
        id: product.ID,
        mop: product.MOP,
        dp: product.DP,
        ap: product.AP,
        mrp: product.MRP,
        branch: product.Branch,
        realpratetax: product.RealPrateTax,
        quantity: qtyNumber,
        uniqueCode,
        selectedVariant, // Track variant in local storage
      });
    }

    // Save to localStorage
    localStorage.setItem("productData", JSON.stringify(existingData));

    const price = getNumericPrice(product);

    // Send to API
    try {
      const payload = {
        itemId: product.ID,
        uniqueCode, // Use the correct one
        itemName: product.ItemName,
        itemPrice: price,
        quantity: quantityDifference,
        ledname,
        ledcode,
        ledemail: ledemail || "no email",
      };
      console.log("Payload to API:", payload);

      const res = await axios.post(
        `${apiBaseUrl}/cart/add/JAPAN_ACCESORIES`,
        payload
      );

      console.log("API Response:", res.data);

      if (res.data.success) {
        toast.success("Item added to cart");
      } else {
        toast.error("Failed to sync with server");
      }
    } catch (err) {
      // console.error("Add to cart error:", err);
      // toast.error("Server error: unable to sync cart");
      console.error(
        "Add to cart error:",
        err?.response?.data || err.message || err
      );
      toast.error("Server error: unable to sync cart");
    }

    setQuantities((prev) => ({ ...prev, [product.ID]: "" }));
  };

  const handleQuantity = (e, product) => {
    const { value } = e.target;

    if (value === "" || (/^\d+$/.test(value) && Number(value) >= 0)) {
      setQuantities((prevQuantities) => ({
        ...prevQuantities,
        [product.ID]: value,
      }));
    }
  };

  const handleQuantityChange = (productId, value) => {
    setQuantities((prev) => ({
      ...prev,
      [productId]: value,
    }));
  };

  const availabilityCheck = (product) => {
    return product.Qty > 1 ? `${product.Qty} In Stock` : "Out of Stock";
  };

  // const handleClick = () => {
  //     const currentUrl = window.location.href;
  //     const message = `${currentUrl}`;
  //     const encodedMessage = encodeURIComponent(message);
  //     const whatsappUrl = `https://api.whatsapp.com/send?text=${encodedMessage}`;

  //     console.log("WhatsApp URL:", whatsappUrl); // Debugging line to check the URL
  //     window.open(whatsappUrl, "_blank");
  // };

  const tabStyle = (tab) =>
    `py-2 px-4 border-b-2 ${
      activeTab === tab
        ? "border-[#8B0000] text-black font-semibold"
        : "border-transparent text-[#6B7280] hover:text-black"
    }`;

  const renderPriceInfo = (product) => {
    if (!customerType) {
      return <span id="h3">MRP: ₹ {product.MRP}</span>;
    }

    switch (customerType) {
      case "CUSTOMER":
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            <div>
              <div id="h3">MOP: ₹ {product.MOP}</div>
              <div id="h3">MRP: ₹ {product.MRP}</div>
            </div>
            <div>
              {/* <span className="text-[#d1d5db] font-normal text-sm">₹ </span>
                            <span className="text-[#d1d5db] line-through font-normal text-sm">{product.MRP}</span> */}
            </div>
          </div>
        );
      case "AGENT":
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            <div>
              <div id="h3">AP: ₹ {product.AP}</div>
              <div id="h3">MOP: ₹ {product.MOP}</div>
            </div>

            {/* <div id="h3">MRP: ₹ {product.MRP}</div> */}
          </div>
        );
      case "DEALER":
        // return <span id="h3">DP: ₹ {product.DP}</span>;
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            <div>
              <div id="h3">DP: ₹ {product.DP}</div>
              <div id="h3">MOP: ₹ {product.MOP}</div>
            </div>

            {/* <div id="h3">MRP: ₹ {product.MRP}</div> */}
          </div>
        );
      case "JS_EMPLOYEE":
      case "TK_EMPLOYEE":
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            <div>
              <div id="h3">Branch: {product.Branch}</div>
              {/* <div id="h3">MRP: ₹ {product.MRP}</div> */}
            </div>
          </div>
        );
      case "JS_MANAGER":
      case "TK_MANAGER":
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            <div>
              <div id="h3">Rate: ₹{product.RealPrateTax}</div>
              {/* <div id="h3">MRP: ₹ {product.MRP}</div> */}
            </div>
          </div>
        );
      default:
        return (
          <div className="flex flex-row justify-between items-center w-full gap-2">
            {/* <span id="h3">MOP: ₹ {product.MOP}</span>
                        &nbsp;&nbsp;&nbsp;&nbsp; */}
            <div id="h3">MRP: ₹ {product.MRP}</div>
          </div>
        );
    }
  };

  useEffect(() => {
    const fetchWishlist = async () => {
      const ledcode = localStorage.getItem("Ledcode");
      try {
        const res = await axios.get(
          `${apiBaseUrl}/wishlist/items/JAPAN_ACCESORIES/${ledcode}`
        );
        if (res.data.success && Array.isArray(res.data.items)) {
          setWishlist(res.data.items);
        }
      } catch (err) {
        console.error("Fetch wishlist error:", err);
      } finally {
        setLoadingWishlist(false); // Important!
      }
    };

    fetchWishlist();
  }, [apiBaseUrl]);

  const getPriceByCustomerType = (product) => {
    const customerType = localStorage.getItem("CustomerType");

    switch (customerType) {
      case "CUSTOMER":
        return product.MOP;
      case "AGENT":
        return product.AP;
      case "DEALER":
        return product.DP;
      case "JS_MANAGER":
      case "TK_MANAGER":
        return product.RealPrateTax;
      case "JS_EMPLOYEE":
      case "TK_EMPLOYEE":
        return product.MRP;
      default:
        return product.MRP;
    }
  };

  const addToWishlist = async (product) => {
    const ledcode = localStorage.getItem("Ledcode");
    const price = getPriceByCustomerType(product);
    const payload = {
      ID: product.ID,
      ItemName: product.ItemName,
      MRP: price,
      ledcode: ledcode,
      Qty: 1,
      uniqueCode: 0,
    };

    try {
      const res = await axios.post(
        `${apiBaseUrl}/wishlist/add/JAPAN_ACCESORIES`,
        payload
      );

      if (res.data.success) {
        const newItem = {
          ID: product.ID,
          ItemName: product.ItemName,
          MRP: price,
          ledcode,
          Qty: 1,
          uniqueCode: 0,
        };
        setWishlist((prev) => [...prev, newItem]);

        toast.success("Added to wishlist");
        console.log(wishlist);
      } else {
        toast.error("Failed to add to wishlist");
      }
    } catch (err) {
      console.error("Add to wishlist error:", err);
      toast.error("Error adding to wishlist");
    }
  };

  const removeFromWishlist = async (productId) => {
    try {
      const res = await axios.delete(
        `${apiBaseUrl}/wishlist/delete/JAPAN_ACCESORIES/${productId}`
      );

      if (res.data.success) {
        setWishlist((prev) => prev.filter((item) => item.ID !== productId)); // Remove from local state
        toast.info("Removed from wishlist");
      } else {
        toast.error("Failed to remove from wishlist");
      }
    } catch (err) {
      console.error("Remove wishlist error:", err);
      toast.error("Error removing from wishlist");
    }
  };

  const toggleWishlist = async (product) => {
    const isInWishlist = wishlist.some((item) => item.ID === product.ID);
    if (isInWishlist) {
      await removeFromWishlist(product.ID);
    } else {
      await addToWishlist(product);
    }
  };

  return (
    <div className="bg-[#F7F7F7]">
      {/* navbar  */}
      <div className="sticky top-0 z-50">
        <Navbar />
      </div>
      <div className="max-w-screen-xl mx-auto">
        {fullProduct.map((product, index) => (
          <div className="w-full px-6 lg:px-16 py-4 grid grid-cols-1 lg:grid-cols-2 gap-10">
            <div>
              {/* Left Section - Images */}
              <div>
                {/* Main Image */}
                <div className="flex w-[50%] h-[60vh] mx-auto ">
                  <img
                    src={selectedImage}
                    alt="Main"
                    className="   object-contain rounded-lg"
                  />
                </div>

                <div className="relative mt-6">
                  {/* Left Button */}
                  <button
                    onClick={scrollLeft}
                    className="absolute left-0 top-1/2 transform -translate-y-1/2 z-10 bg-[#D1D5DB] shadow-md p-2 rounded-full"
                  >
                    <FaChevronLeft />
                  </button>

                  {/* Thumbnail Scrollable Container */}
                  <div
                    ref={thumbnailContainerRef}
                    className="flex gap-4 overflow-x-auto scrollbar-hide px-10"
                    style={{
                      scrollBehavior: "smooth",
                      scrollbarWidth: "none",
                      msOverflowStyle: "none",
                    }}
                  >
                    {images.map((img, index) => (
                      <div
                        key={index}
                        onClick={() => setSelectedImage(img)}
                        className={`min-w-[80px] h-[80px] border rounded-lg p-2 cursor-pointer ${
                          selectedImage === img
                            ? "border-[#3B82F6]"
                            : "border-[#D1D5DB]"
                        }`}
                      >
                        <img
                          src={img}
                          alt={`thumb-${index}`}
                          className="object-contain h-full w-full"
                        />
                      </div>
                    ))}
                  </div>

                  {/* Right Button */}
                  <button
                    onClick={scrollRight}
                    className="absolute right-0 top-1/2 transform -translate-y-1/2 z-10 bg-[#D1D5DB] shadow-md p-2 rounded-full"
                  >
                    <FaChevronRight />
                  </button>
                </div>
              </div>
            </div>

            {/* Right Section - Details */}

            <div>
              <h2 className="text-2xl font-bold text-black">
                {product.ItemName}
              </h2>
              {/* <div className="flex items-center text-sm mt-2 text-[#4B5563]">
                                <div className="flex gap-1 m-2">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} className="text-[#FACC15] text-sm" />
                                    ))}
                                </div>
                                4.7 Star Rating <span className="ml-1 text-[#6B7280]">(21,671 User feedback)</span>
                            </div> */}

              {/* <p className="mt-2 text-[#374151]">
                                Apple MacBook AIR Apple M2
                                <p>(16 GB/256 GB SSD/macOS Sequoia) MC7W4HN/A (13.6 Inch, Starlight, 1.24 kg)</p>
                            </p> */}

              <div className="mt-3 text-sm">
                {/* <p>
                                    Availability:{" "}
                                    <span className="text-[#16A34A] font-semibold">{availabilityCheck(product)}</span>{" "}
                                </p> */}
                {/* <p>
                                    Brand: <span className="font-semibold">Apple</span>
                                </p>
                                <p>
                                    Category: <span className="font-semibold">Electronics Devices{}</span>
                                </p> */}
              </div>

              {/* Price */}
              <div className="mt-4 flex items-center gap-4">
                <span className="text-2xl font-bold text-[#DC2626]">
                  {renderPriceInfo(product)}
                </span>

                {customerType === "CUSTOMER" && (
                  <>
                    <span className="text-[#9CA3AF] line-through">
                      ₹ {product.MRP}
                    </span>
                    <span className="bg-[#FACC15] text-black text-xs px-2 py-1 rounded ml-2">
                      {Math.floor(
                        ((product.MRP - product.MOP) / product.MRP) * 100
                      )}
                      % OFF
                    </span>
                  </>
                )}
              </div>

              <div className="flex md:items-center flex-col md:flex-row w-full gap-4">
                {/* Color Options */}
                {/* <div className="mt-4 flex flex-col gap-2 w-[50%]">
                                    <label className="text-sm font-semibold">Color</label>
                                    <div className="flex gap-3">
                                        <img src={macbook} alt="color" className="w-12 border rounded cursor-pointer" />
                                        <img
                                            src={macbook}
                                            alt="color"
                                            className="h-10 border-2 border-black rounded cursor-pointer"
                                        />
                                    </div>
                                </div> */}
                {/* System Memory */}
                {/* <div className="md:mt-4 flex flex-col gap-2 w-[50%]">
                                    <label className="text-sm font-semibold">System Memory</label>
                                    <div className="flex gap-3">
                                        {options.map((val) => (
                                            <button
                                                key={val}
                                                onClick={() => setSelectedVariant(val)}
                                                className={`px-4 py-2 text-sm border rounded transition-all duration-200 ${
                                                    selectedVariant === val
                                                        ? "border-black bg-[black] text-[white]"
                                                        : "border-[#D1D5DB] text-[black]"
                                                }`}
                                            >
                                                {val}
                                            </button>
                                        ))}
                                    </div>
                                </div> */}
              </div>

              {/* Size Select */}
              {/* <div className="flex items-center gap-4">
                                <div className="flex gap-4 mt-4 w-full">
                                    <select className="border rounded px-4 py-2 w-full">
                                        <option>14-inch Liquid Retina XDR display</option>
                                    </select>
                                </div>
                                <div className="flex gap-4 mt-4 w-full">
                                    <select className="border rounded px-4 py-2 w-full">
                                        <option>16GB unified memory</option>
                                    </select>
                                </div>
                            </div> */}

              {/* Quantity and Buttons */}
              {customerType !== "AGENT" && (
                <div className="flex items-center gap-4 mt-4">
                  <div className="flex w-20 md:w-24 h-11 bg-white justify-center items-center font-medium ">
                    <input
                      type="number"
                      placeholder="Qty"
                      className="w-full p-2 text-center border border-gray-100 rounded"
                      value={quantities[product.ID] ?? ""}
                      onChange={(e) => handleQuantity(e, product)}
                      // onBlur={(e) => handleBlurOrEnter(e, product)}
                      // onKeyDown={(e) => handleBlurOrEnter(e, product)}
                      min="0"
                      onWheel={(e) => e.target.blur()}
                    />
                  </div>

                  <button
                    className="border border-[#8B0000] bg-[#8B0000] text-[white]  px-3 py-2.5 md:px-6 md:py-2.5 rounded font-semibold flex items-center gap-2"
                    onClick={() => addToCart(product)}
                  >
                    <span className="text-sm">ADD TO CART</span>
                    <LuShoppingCart />
                  </button>

                  <button className="border border-[#8B0000] bg-[white] text-[#8B0000] px-3 py-2 md:px-6 md:py-2 rounded font-semibold">
                    <span className="text-sm">BUY NOW</span>
                  </button>
                </div>
              )}

              {/* Wishlist + Compare */}
              {!loadingWishlist && customerType === "CUSTOMER" && (
                <div className="flex items-center gap-6 mt-4 text-sm text-gray-600">
                  {/* <span className="cursor-pointer">
                                        <button type="" className="flex items-center gap-2 ">
                                            <FaBalanceScale size={20} /> Add to Compare
                                        </button>
                                    </span> */}
                  <div className="cursor-pointer">
                    <button
                      type=""
                      className="flex items-center gap-2"
                      onClick={() => toggleWishlist(product)}
                    >
                      {wishlist.some((item) => item.ID === product.ID) ? (
                        <div className="flex items-center gap-2">
                          <FaHeart size={20} className="text-[red]" /> Remove
                          from Wish List
                        </div>
                      ) : (
                        <div className="flex items-center gap-2">
                          <FaRegHeart size={20} />
                          Add to Wish List
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              )}

              {/* Guarantee Section */}
              {/* <div className="mt-4 text-sm text-[#374151] border border-[#cedcf0] rounded-md p-2 w-fit">
                                <p className="font-semibold mt-2 px-2">100% Guarantee Safe Checkout</p>
                                <div className="flex items-center gap-2 px-2">
                                    <img src={paypal} alt="paypal" className="h-5" />
                                    <img src={mastercard} alt="mastercard" className="h-7" />
                                    <img src={visa} alt="visa" className="h-10" />
                                    <img src={amex} className="h-5" alt="amex" />
                                </div>
                            </div> */}
            </div>
          </div>
        ))}
      </div>

      <div>
        <div className="w-full mt-10 px-4 sm:px-6 md:px-10">
          {/* Tab Navigation */}
          <div className="flex flex-wrap gap-4 sm:gap-6 border-b border-[#dfe2e8] items-center justify-center text-sm sm:text-base overflow-x-auto">
            <button
              onClick={() => setActiveTab("description")}
              className={tabStyle("description")}
            >
              DESCRIPTION
            </button>
            <button
              onClick={() => setActiveTab("additional")}
              className={tabStyle("additional")}
            >
              ADDITIONAL INFORMATION
            </button>
            <button
              onClick={() => setActiveTab("specification")}
              className={tabStyle("specification")}
            >
              SPECIFICATION
            </button>
            {/* <button onClick={() => setActiveTab("review")} className={tabStyle("review")}>
                            REVIEW
                        </button> */}
          </div>

          {/* Tab Content */}
          <div className="mt-6 text-[#374151] leading-relaxed text-sm sm:text-base">
            {activeTab === "description" && (
              <>
                <p className="text-[#6B7280] italic">Description</p>
              </>
            )}

            {activeTab === "additional" && (
              <p className="text-[#6B7280] italic">
                Additional product information
              </p>
            )}

            {activeTab === "specification" && (
              <p className="text-[#6B7280] italic">Specification details</p>
            )}

            {activeTab === "review" && (
              <p className="text-[#6B7280] italic">Customer reviews</p>
            )}

            {/* Features */}
            {/* <div className="mt-6">
                            <h4 className="font-semibold mb-3">FEATURES</h4>
                            <ul className="space-y-2">
                                <li className="flex items-center gap-2">
                                    <FaAward className="text-[#F97316]" />
                                    Free 1 Year Warranty
                                </li>
                                <li className="flex items-center gap-2">
                                    <FaCreditCard className="text-[#F97316]" />
                                    Secure payment method
                                </li>
                            </ul>
                        </div> */}
          </div>
        </div>
      </div>

      <div className="w-full h-auto  flex flex-col  justify-center items-center  lg:px-[7%] px-[2%] gap-12 mt-[6%]">
        <div className="w-full   flex flex-row items-center justify-between ">
          <div className="flex-grow flex items-center justify-center">
            <h2 className="lg:text-xl font-display font-[700] border-b-2 border-black">
              Similar Products
            </h2>
          </div>
          <span
            className="text-xs font-[500] border-b-2 cursor-pointer "
            onClick={items}
          >
            See more
          </span>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-x-4  w-full mt-5">
          {products.map((product, index) => (
            <div
              key={product.ID}
              className="product-card w-full flex flex-col gap-1  rounded-md mb-4  border-[#d1d5db] bg-[white]"
            >
              <div
                key={product.ID}
                className="relative group w-full lg:h-[313px] md:h-[270px] sm:h-[250px] h-[200px] flex flex-col justify-center items-center bg-[white] gap-[2%] cursor-pointer overflow-hidden"
              >
                {/* Wishlist Button */}
                {!loadingWishlist && customerType === "CUSTOMER" && (
                  <button
                    className="absolute top-3 right-3 text-[#d1d5db] hover:text-[red]"
                    onClick={() => toggleWishlist(product)}
                  >
                    {wishlist.some((item) => item.ID === product.ID) ? (
                      <FaHeart size={20} className="text-[red]" />
                    ) : (
                      <FaRegHeart size={20} />
                    )}
                  </button>
                )}

                {/* Product Image */}
                <div
                  onClick={() =>
                    fullimage(product.ItemName, product.ID, customerType)
                  }
                  className="w-[68%] h-[68%] flex justify-center items-center"
                >
                  <img
                    src={`${apiLocalUrl}/uploads/${
                      product.ID
                    }.jpg?v=${Date.now()}`}
                    alt={product.ItemName}
                    className="size-[90%] object-contain mix-blend-multiply"
                  />
                </div>

                {/* Add to Cart Section */}

                <div className=" w-full text-center">
                  {customerType !== "AGENT" && (
                    <div className="mx-4 bg-gradient-to-r from-[#8b0000] to-[#d78e8e] rounded text-[white] p-2 flex items-center justify-center">
                      <div className="flex">
                        <span className="text-lg font-medium">🛒</span>
                        <span className=" hidden md:flex lg:text-md sm:text-sm text-xs font-medium items-center">
                          Add to Cart
                        </span>
                      </div>

                      <input
                        type="text"
                        min="1"
                        value={quantities[product.ID] || ""}
                        onChange={(e) =>
                          handleQuantityChange(product.ID, e.target.value)
                        }
                        // onBlur={() => handleBlur(product.ID)}
                        className="md:w-12 w-10 px-1 py-0.5 text-[black] rounded  mx-1 lg:text-md sm:text-sm text-xs font-medium"
                      />
                      <span
                        role="button"
                        onClick={() => handleAddToCart(product.ID)}
                        className="cursor-pointer hover:underline"
                      >
                        <FaArrowAltCircleRight className="md:size-6 size-5" />
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div
                onClick={() =>
                  fullimage(product.ItemName, product.ID, customerType)
                }
                className="w-full md:h-[18vh] h-auto flex flex-col items-start py-2 gap-1 px-4 rounded-b-[10px] bg-[white]"
              >
                {/* <p className="text-sm text-[#a4a7ab] mb-1">Category</p> */}
                <span className="lg:text-md sm:text-sm text-xs font-medium text-left w-[70%]">
                  {product.ItemName}
                </span>
                {/* Rating */}
                {/* <div className="flex gap-1 ">
                                    {[...Array(5)].map((_, i) => (
                                        <FaStar key={i} className="text-[#FACC15] text-sm" />
                                    ))}
                                </div> */}

                <div className="flex flex-row justify-between items-center w-full gap-2">
                  <span className="lg:text-md sm:text-sm text-xs text-[#2563EB] font-semibold text-left w-full">
                    {renderPriceInfo(product)}
                  </span>
                  {/* <span className="text-[#d1d5db] text-sm">₹</span> */}
                  {/* <span className="text-[#d1d5db] line-through text-sm">{product.MRP}</span> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:mt-[6%] mt-[10%]">
        <Footer />
      </div>
      <ToastContainer autoClose={1500} />
    </div>
  );
}
